import React from 'react';
import ReactDOM from 'react-dom/client';
import LOGIN from './Pages/Login';
import SITE_ADMIN_LIST from './Pages/SiteList';
import SITE_ADMIN from './Pages/SiteAdmin';
import GATEWAY from './Pages/GatewaySensor';
import TOPMENU from './Pages/Topmenu';
import GATEWAYADMIN from './Pages/GatewayAdmin';
import ADMINLIST from './Pages/SiteList';
import SENSORADMIN from './Pages/SensorAdmin';
import INFOADMIN from './Pages/InfoAdmin';
import DASHBOARD from './Pages/Dashboard';
import GRAPH from './Pages/GraphModal';
import SENSORCONFIG from './Pages/SensorSetting';
import LIFF from './Pages/liff';
import Topmenu from "./Pages/Menu";
import Download from "./Pages/Downloads";
import LiffLogin from './Pages/LiffLogin';
import ENVSETTING from "./Pages/EnvSetting";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CookiesProvider } from "react-cookie";
import { Liff } from "@line/liff/core";
import LiffNotification from "./Pages/LiffNotification";
import VConsole from 'vconsole';
//const vConsole = new VConsole();
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <CookiesProvider>
    <div id="loaderScreen"
         style={{zIndex: "100000",
           height: "100%",
           width: "100%",
           position:"absolute",
           top: "0", left: "0",
           backgroundColor: "rgba(0,0,0,.5)",
             display: "none",
         }}
    >
        <div className="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div id="contentToPrint"
         style={{
           width: "210mm",
           zIndex: "1000000",
           backgroundColor: "white",
           display: "none",
           position:"absolute",
           top: "0", left: "0",
           height: "100%"
    }}>
    </div>
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={
          <LOGIN />
        } />
        <Route path="/site_admin_list" element={
          <SITE_ADMIN_LIST />
        } />
        <Route path="/site_admin" element={
          <SITE_ADMIN />
        } />
        <Route path="/gateway_sensor/:siteId?/:siteRecno" element={
          <GATEWAY />
        } />
        <Route path="/topmenu" element={
          <TOPMENU />
        } />
        <Route path="/gateway_admin" element={
          <GATEWAYADMIN />
        } />
        <Route path="/admin_list" element={
          <ADMINLIST />
        } />
        <Route path="/sensor_admin" element={
          <SENSORADMIN />
        } />
        <Route path="/info_admin" element={
          <INFOADMIN />
        } />

        {/* ログイン画面から */}
        <Route path="/dashboard/:userId/:siteRecno" element={<DASHBOARD />} />

        <Route path="/graph" element={
          <GRAPH />
        } />
        <Route path="/sensor_config/:siteId/:siteRecno" element={
          <SENSORCONFIG />
        } />
        <Route path="/download/:siteId/:siteRecno" element={
          <Download />
        } />
        <Route path="/liff" element={
          <LIFF />
        } />
        <Route path="/liff_login" element={
          <LiffLogin />
        } />
        <Route path="/liff_notification/:idToken?" element={
          <LiffNotification />
        } />
        <Route path="/menu/:siteId/:siteRecno" element={
          <Topmenu />
        } />
        <Route path="/env_setting/:siteId/:siteRecno" element={
          <ENVSETTING />
        } />
      </Routes>
    </BrowserRouter>
  </CookiesProvider>
);
